import { createSelector } from "reselect";
import { loadingMainQuerySelector } from "@xingternal/platform-layout-selectors";
const layoutSwitcherSelector = createSelector(loadingMainQuerySelector, (loadingMainQuery) => ({
  loadingMainQuery
}));
export {
  layoutSwitcherSelector
};
